//
//
//
//
//

import { mapGetters } from "vuex";

import ContactCard from "./ContactCard";

export default {
	name: "AppGrid",
	components: {
		ContactCard
	},
	computed: {
		...mapGetters([
			"contactsDisplayList"
		]),
	},
	methods: {
		idVal(contact) {
			let str = "";
			if (!!contact.emailAddress) str += contact.emailAddress;
			if (!!contact.phoneNumberLong) str += contact.phoneNumberLong.toString();
			str += Math.ceil(Math.random() * 100000000000000000).toString();
			return str;
		},
	},
}
